/* Favourite flowers (docs/favourite-flowers.md).

   Two things live here:
   - the picker, <fb-favourite-flowers> (sections/fb-favourite-flowers.liquid):
     tap the flowers you or someone you love adore, then save them to the
     Birthday Club service, which says when each comes back into season;
   - the summary, [data-fb-flowers-summary] on the Reminders page: a signed-in
     member's favourites, per person, with a way to add or change them.

   Flower names and photos come from snippets/fb-flowers-data.liquid. The
   service stores handles only. */
(function (root, factory) {
  var mod = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = mod;
  root.FBFavouriteFlowers = mod;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var MAX_NAME = 40;
  // The service's own rule (Birthday-Club src/lib/flowers/favourites.ts):
  // letters, spaces and the punctuation names carry. No digits or links.
  var NAME_RE = /^[\p{L}\p{M}][\p{L}\p{M}' .&-]*$/u;
  var NEW_KEY = '__new';
  var PICKER_URL = '/pages/favourite-flowers';
  var CONFIRM_NOTE = 'Check your inbox and tap the link to confirm. If you\u2019ve confirmed before, you\u2019re all set.';

  var STARTER_FLOWERS = /^(garden rose|rose|tulip|peony|peonies|hydrangea|orchid|dahlia|sunflower|freesia|ranunculus|lily|lilies|gerbera|lisianthus)s?$/i;
  function flowerVisible(flower, filter, query, chosen) {
    var matches = !query || flower.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    return matches && (filter === 'all' || (filter === 'popular' && (!!query || STARTER_FLOWERS.test(flower.name))) || (filter === 'season' && flower.inSeason) || (filter === 'chosen' && chosen.indexOf(flower.handle) !== -1));
  }

  /* ---------- pure helpers (tests/fb-favourite-flowers.test.js) ---------- */

  function cleanName(raw) {
    var name = String(raw == null ? '' : raw).normalize('NFC').replace(/\s+/g, ' ').trim();
    if (!name) return { value: '', error: 'Add their first name.' };
    if (name.length > MAX_NAME) return { value: name, error: 'Keep it to 40 letters.' };
    if (!NAME_RE.test(name)) return { value: name, error: 'Use letters only, like Linda or Mum.' };
    return { value: name, error: null };
  }

  function forKey(name) {
    return name ? String(name).toLocaleLowerCase('en-AU') : '';
  }

  function possessive(name) {
    return /s$/i.test(name) ? name + '’' : name + '’s';
  }

  /* "Anemone", "Anemone and Peony", "Anemone, Peony and Tulip",
     "Anemone, Peony and 3 more". */
  function listNames(names, max) {
    max = max || 3;
    var list = (names || []).filter(Boolean);
    if (list.length <= 1) return list[0] || '';
    if (list.length <= max) return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
    return list.slice(0, max - 1).join(', ') + ' and ' + (list.length - (max - 1)) + ' more';
  }

  function readCatalogue(scope) {
    var node = scope && scope.querySelector ? scope.querySelector('[data-fb-flowers-data]') : null;
    var raw = [];
    try { raw = JSON.parse(node ? node.textContent : '[]'); } catch (_) { raw = []; }
    var list = (Array.isArray(raw) ? raw : []).filter(function (f) {
      return f && typeof f.handle === 'string' && /^[a-z0-9][a-z0-9-]{0,63}$/.test(f.handle) && typeof f.name === 'string';
    });
    var byHandle = {};
    list.forEach(function (f) { byHandle[f.handle] = f; });
    return { list: list, byHandle: byHandle };
  }

  function flowerName(catalogue, handle) {
    var f = catalogue.byHandle[handle];
    if (f) return f.name;
    return handle.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }

  /* The sentence on the done screen. */
  function doneMessage(catalogue, handles, name) {
    var names = listNames(handles.map(function (h) { return flowerName(catalogue, h); }));
    if (!handles.length) return name ? 'We’ve cleared ' + possessive(name) + ' favourites.' : 'We’ve cleared your favourites.';
    if (name) return 'We’ll let you know when ' + possessive(name) + ' favourites are back in season: ' + names + '.';
    return 'We’ll let you know when ' + names + (handles.length === 1 ? ' is' : ' are') + ' back in season.';
  }

  function trayMessage(count, name) {
    if (count === 0) return name ? 'Nothing chosen for ' + name : 'Nothing chosen yet';
    var flowers = count === 1 ? '1 flower' : count + ' flowers';
    return flowers + ' for ' + (name || 'you');
  }

  /* The words for a failed request. The service's own messages (a bad
     email, a wrong code, too many tries) are written for customers, so they
     are shown as they are. Anything else (no connection, a blocked request,
     a server fault) gets the fallback, never a browser's "Failed to fetch". */
  function friendlyError(error, fallback) {
    var status = error && error.status;
    var fromService = error && error.payload && error.payload.error && typeof error.message === 'string';
    if (fromService && status >= 400 && status < 500) return error.message;
    return fallback;
  }

  /* Request bodies, in the shape the service validates. */
  function publicPayload(input) {
    var body = { flowers: input.flowers.slice(), email: input.email };
    if (input.forName) body.forName = input.forName;
    if (input.sms) {
      body.sms = true;
      body.phone = input.phone;
      if (input.smsPass) body.smsPass = input.smsPass;
      else if (input.code) body.code = input.code;
    }
    if (input.touchpoint) body.touchpoint = input.touchpoint;
    return body;
  }

  function memberPayload(input) {
    var body = { flowers: input.flowers.slice() };
    if (input.friendId) body.friendId = input.friendId;
    else if (input.forName) body.forName = input.forName;
    if (input.touchpoint) body.touchpoint = input.touchpoint;
    return body;
  }

  /* Where a visit came from: `?via=` on the link in (an email, the Journal,
     Reminders), else the section's campaign label. Cleaned the way the
     service cleans it: lowercase letters, digits, - and _, 60 at most. */
  function touchpointFrom(search, fallback) {
    var via = '';
    try { via = new root.URLSearchParams(search || '').get('via') || ''; } catch (_) {}
    via = via.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 60);
    return via || fallback || '';
  }

  function pickerUrl(group, via) {
    var params = [];
    if (group && group.friendId) params.push('friend=' + encodeURIComponent(group.friendId));
    else if (group && group.forName) params.push('for=' + encodeURIComponent(group.forName));
    if (via) params.push('via=' + encodeURIComponent(via));
    return PICKER_URL + (params.length ? '?' + params.join('&') : '');
  }

  function el(tag, className, text) {
    var node = root.document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function thumb(catalogue, handle, className) {
    var f = catalogue.byHandle[handle];
    if (f && f.image) {
      var img = el('img', className);
      img.src = f.image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 80;
      img.height = 80;
      return img;
    }
    var initial = el('span', className + ' ' + className + '--blank', flowerName(catalogue, handle).charAt(0));
    return initial;
  }

  function apiFor(element) {
    var API = root.FBRemindersAPI;
    var base = element.getAttribute('data-api-base') || '';
    if (!API || !base) return null;
    try { return API.create(base); } catch (_) { return null; }
  }

  /* ---------- the picker ---------- */

  function Picker(element) {
    this.el = element;
    this.catalogue = readCatalogue(element);
    this.api = apiFor(element);
    this.touchpoint = touchpointFrom(root.location && root.location.search, element.getAttribute('data-touchpoint'));
    // Per person, keyed by forKey: what is chosen now, and what the service
    // holds for a member (to tell an edit from nothing to save).
    this.chosen = {};
    this.saved = {};
    this.current = { key: '', name: null, friendId: null };
    this.member = null;
    this.contact = null;
    this.smsPass = null;
    this.filter = 'popular';
    this.query = '';
    this.lastFocus = null;
  }

  Picker.prototype.q = function (selector) { return this.el.querySelector(selector); };
  Picker.prototype.qa = function (selector) { return Array.prototype.slice.call(this.el.querySelectorAll(selector)); };

  Picker.prototype.selection = function () {
    if (!this.chosen[this.current.key]) this.chosen[this.current.key] = [];
    return this.chosen[this.current.key];
  };

  Picker.prototype.init = function () {
    var self = this;
    this.bind();
    var params = new root.URLSearchParams(root.location.search);
    var back = this.q('[data-fbf-reminders-back]');
    if (back) back.hidden = !/^reminders(?:-|$)/.test(params.get('via') || '');
    var forParam = params.get('for');
    if (forParam && !cleanName(forParam).error) this.startNewPerson(cleanName(forParam).value);
    var flower = params.get('flower');
    if (flower && this.catalogue.byHandle[flower]) {
      this.filter = 'all';
      this.toggle(flower, true);
      var item = this.q('[data-fbf-item][data-handle="' + flower + '"]');
      if (item && item.scrollIntoView) root.setTimeout(function () { item.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 200);
    }
    this.render();
    this.loadMember(params.get('friend'));
    root.document.addEventListener('fb-reminders:verified', function () {
      if (self.api) self.api.clearMe();
      self.closeSheet();
      self.loadMember(self.current.friendId);
    });
  };

  Picker.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (event) {
      var target = event.target;
      var tile = target.closest && target.closest('[data-fbf-tile]');
      if (tile) {
        var item = tile.closest('[data-fbf-item]');
        self.toggle(item.getAttribute('data-handle'));
        self.render();
        return;
      }
      var who = target.closest && target.closest('[data-fbf-who-option]');
      if (who) return self.choosePerson(who);
      var filter = target.closest && target.closest('[data-fbf-filter]');
      if (filter) {
        self.filter = filter.getAttribute('data-fbf-filter');
        return self.render();
      }
      if (target.closest && target.closest('[data-fbf-continue]')) return self.continueOn();
      if (target.closest && target.closest('[data-fbf-another]')) return self.another();
      if (target.closest && target.closest('[data-fbf-sign-in]')) return self.closeSheet(true);
      if (target.closest && target.closest('[data-fbf-close]')) return self.closeSheet();
    });
    var search = this.q('[data-fbf-search]');
    if (search) search.addEventListener('input', function () { self.query = search.value.trim().toLowerCase(); self.render(); });
    var name = this.q('[data-fbf-for-name]');
    if (name) {
      name.addEventListener('input', function () {
        self.setNameError(null);
        self.renderTray();
      });
      name.addEventListener('change', function () { self.adoptTypedName(); });
    }
    var sms = this.q('[data-fbf-sms]');
    if (sms) sms.addEventListener('change', function () {
      self.q('[data-fbf-phone-wrap]').hidden = !sms.checked;
      if (!sms.checked) self.showCodeStep(false);
    });
    var form = this.q('[data-fbf-state="contact"]');
    if (form) {
      form.addEventListener('submit', function (event) { event.preventDefault(); self.submitContact(); });
      // A code is for the number it was sent to: editing either starts over.
      ['email', 'phone'].forEach(function (name) {
        form.elements[name].addEventListener('input', function () { if (!self.q('[data-fbf-code-wrap]').hidden) self.showCodeStep(false); });
      });
    }
    var resend = this.q('[data-fbf-resend]');
    if (resend) resend.addEventListener('click', function () { self.sendCode(form.elements.phone.value.trim()); });
    root.document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !self.q('[data-fbf-sheet]').hidden) self.closeSheet();
    });
  };

  Picker.prototype.toggle = function (handle, on) {
    var list = this.selection();
    var at = list.indexOf(handle);
    if (on === true && at !== -1) return;
    if (at === -1) list.push(handle);
    else list.splice(at, 1);
  };

  /* The name typed for "Someone I love", or the chosen person's. */
  Picker.prototype.personName = function () {
    if (this.current.key !== NEW_KEY) return this.current.name;
    var input = this.q('[data-fbf-for-name]');
    var name = cleanName(input ? input.value : '');
    return name.error ? null : name.value;
  };

  Picker.prototype.startNewPerson = function (name) {
    var carry = this.chosen[NEW_KEY] || [];
    this.current = { key: NEW_KEY, name: null, friendId: null };
    this.chosen[NEW_KEY] = carry;
    var input = this.q('[data-fbf-for-name]');
    if (input && name != null) input.value = name;
  };

  Picker.prototype.choosePerson = function (button) {
    var key = button.getAttribute('data-for-key');
    if (key === NEW_KEY) {
      this.startNewPerson('');
      this.chosen[NEW_KEY] = [];
      this.render();
      var input = this.q('[data-fbf-for-name]');
      if (input) input.focus();
      return;
    }
    this.current = {
      key: key,
      name: button.getAttribute('data-for-name') || null,
      friendId: button.getAttribute('data-friend-id') || null
    };
    if (!this.chosen[key]) this.chosen[key] = (this.saved[key] || []).slice();
    this.render();
  };

  Picker.prototype.loadMember = async function (friendParam) {
    if (!this.api) return;
    var me;
    try { me = await this.api.me(); } catch (_) { return; }
    if (!me || !me.signedIn) return;
    var data;
    try { data = await this.api.getMyFlowers(); } catch (_) { return; }
    var self = this;
    this.member = { groups: data.groups || [], people: data.people || [] };
    this.saved = {};
    this.member.groups.forEach(function (group) {
      var key = group.friendId ? 'friend:' + group.friendId : forKey(group.forName);
      self.saved[key] = group.flowers.slice();
    });
    var target = null;
    if (friendParam) target = this.member.people.filter(function (p) { return p.id === friendParam; })[0];
    if (target) {
      var carried = this.selection().slice();
      this.current = { key: 'friend:' + target.id, name: target.name, friendId: target.id };
      this.chosen[this.current.key] = this.merged(this.current.key, carried);
    } else if (this.current.key === NEW_KEY) {
      this.adoptTypedName();
    } else {
      this.chosen[this.current.key] = this.merged(this.current.key, this.selection());
    }
    this.renderWho();
    this.render();
  };

  /* A person's saved flowers with anything picked on top. */
  Picker.prototype.merged = function (key, picked) {
    var list = (this.saved[key] || []).slice();
    (picked || []).forEach(function (h) { if (list.indexOf(h) === -1) list.push(h); });
    return list;
  };

  /* Signed in, a typed name that is already someone (a Reminders person,
     or a name with saved flowers) becomes that person, with their saved
     flowers kept. Otherwise a save for "Linda" would replace Linda's list
     with only what was picked just now. True when it switched. */
  Picker.prototype.adoptTypedName = function () {
    if (!this.member || this.current.key !== NEW_KEY) return false;
    var input = this.q('[data-fbf-for-name]');
    var name = cleanName(input ? input.value : '');
    if (name.error) return false;
    var typed = forKey(name.value);
    var person = this.member.people.filter(function (p) { return forKey(p.name) === typed; })[0];
    var group = this.member.groups.filter(function (g) { return !g.friendId && forKey(g.forName) === typed; })[0];
    var next = person ? { key: 'friend:' + person.id, name: person.name, friendId: person.id }
      : group ? { key: typed, name: group.forName, friendId: null } : null;
    if (!next) return false;
    var picked = this.selection().slice();
    this.chosen[NEW_KEY] = [];
    this.current = next;
    this.chosen[next.key] = this.merged(next.key, picked);
    this.renderWho();
    this.render();
    return true;
  };

  /* The member's people: anyone with favourites first, then everyone else. */
  Picker.prototype.memberOptions = function () {
    var options = [{ key: '', name: null, friendId: null, label: 'Me' }];
    var seen = {};
    var self = this;
    this.member.groups.forEach(function (group) {
      if (!group.forName) return;
      var key = group.friendId ? 'friend:' + group.friendId : forKey(group.forName);
      seen[key] = true;
      options.push({ key: key, name: group.forName, friendId: group.friendId, label: group.forName });
    });
    this.member.people.forEach(function (person) {
      var key = 'friend:' + person.id;
      if (seen[key]) return;
      options.push({ key: key, name: person.name, friendId: person.id, label: person.name });
    });
    if (this.current.key !== '' && this.current.key !== NEW_KEY && !options.some(function (o) { return o.key === self.current.key; })) {
      options.push({ key: this.current.key, name: this.current.name, friendId: this.current.friendId, label: this.current.name });
    }
    return options;
  };

  Picker.prototype.renderWho = function () {
    var group = this.q('[data-fbf-who]');
    if (!group || !this.member) return;
    group.textContent = '';
    this.memberOptions().forEach(function (option) {
      var chip = el('button', 'fbf__chip', option.label);
      chip.type = 'button';
      chip.setAttribute('role', 'radio');
      chip.setAttribute('data-fbf-who-option', '');
      chip.setAttribute('data-for-key', option.key);
      if (option.name) chip.setAttribute('data-for-name', option.name);
      if (option.friendId) chip.setAttribute('data-friend-id', option.friendId);
      group.appendChild(chip);
    });
    var other = el('button', 'fbf__chip fbf__chip--add', '+ Someone else');
    other.type = 'button';
    other.setAttribute('role', 'radio');
    other.setAttribute('data-fbf-who-option', '');
    other.setAttribute('data-for-key', NEW_KEY);
    group.appendChild(other);
  };

  Picker.prototype.render = function () {
    var self = this;
    var chosen = this.selection();
    this.qa('[data-fbf-who-option]').forEach(function (chip) {
      chip.setAttribute('aria-checked', chip.getAttribute('data-for-key') === self.current.key ? 'true' : 'false');
    });
    this.q('[data-fbf-name-wrap]').hidden = this.current.key !== NEW_KEY;
    var heading = this.q('[data-fbf-heading]');
    if (heading) {
      if (!heading.getAttribute('data-default')) heading.setAttribute('data-default', heading.textContent);
      heading.textContent = this.current.name ? 'What does ' + this.current.name + ' love?' : heading.getAttribute('data-default');
    }
    var items = this.qa('[data-fbf-item]');
    var counts = { all: items.length, season: items.filter(function (item) { return item.getAttribute('data-in-season') === 'true'; }).length, chosen: chosen.length };
    var labels = { all: 'All', season: 'In season', chosen: 'Your favourites' };
    this.qa('[data-fbf-filter]').forEach(function (button) {
      var key = button.getAttribute('data-fbf-filter');
      if (labels[key]) button.textContent = labels[key] + ' (' + counts[key] + ')';
      button.setAttribute('aria-pressed', button.getAttribute('data-fbf-filter') === self.filter ? 'true' : 'false');
    });
    var shown = 0;
    this.qa('[data-fbf-item]').forEach(function (item) {
      var handle = item.getAttribute('data-handle');
      var on = chosen.indexOf(handle) !== -1;
      var tile = item.querySelector('[data-fbf-tile]');
      tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      item.classList.toggle('is-chosen', on);
      var visible = flowerVisible({ handle: handle, name: item.getAttribute('data-name') || '', inSeason: item.getAttribute('data-in-season') === 'true' }, self.filter, self.query, chosen);
      item.hidden = !visible;
      if (visible) shown++;
    });
    var noMatch = this.q('[data-fbf-no-match]');
    if (noMatch) {
      noMatch.hidden = shown > 0 || this.catalogue.list.length === 0;
      noMatch.textContent = self.query ? 'No flowers match. Try another name.' : self.filter === 'chosen' ? 'No favourites chosen yet. Browse the flowers and tap the ones you love.' : self.filter === 'season' ? 'None of these flowers are in season right now. Browse all flowers to save your favourites.' : 'Browse all flowers to find your favourites.';
    }
    var browseAll = this.q('[data-fbf-browse-all]');
    if (browseAll) { browseAll.hidden = self.filter !== 'popular' || !!self.query || shown >= items.length; browseAll.textContent = 'Browse all ' + items.length + ' flowers'; }
    this.renderTray();
  };

  /* Something to save. A member's save replaces the list, so any change
     counts. Signed out, a save only adds, so only a flower not yet saved. */
  Picker.prototype.dirty = function () {
    var chosen = this.selection();
    var saved = this.saved[this.current.key] || [];
    if (!this.member) return chosen.some(function (h) { return saved.indexOf(h) === -1; });
    return chosen.slice().sort().join(',') !== saved.slice().sort().join(',');
  };

  Picker.prototype.renderTray = function () {
    var tray = this.q('[data-fbf-tray]');
    var chosen = this.selection();
    var visible = this.dirty();
    tray.hidden = !visible;
    this.el.classList.toggle('fbf--tray-open', visible);
    if (!visible) return;
    var thumbs = this.q('[data-fbf-tray-thumbs]');
    thumbs.textContent = '';
    var self = this;
    chosen.slice(-5).forEach(function (handle) { thumbs.appendChild(thumb(self.catalogue, handle, 'fbf-tray__thumb')); });
    var name = this.current.key === NEW_KEY ? this.personName() : this.current.name;
    this.q('[data-fbf-tray-text]').textContent = trayMessage(chosen.length, name);
    this.q('[data-fbf-continue]').textContent = this.member || this.contact ? 'Save' : 'Continue';
  };

  Picker.prototype.setNameError = function (message) {
    var wrap = this.q('[data-fbf-name-wrap]');
    var error = wrap.querySelector('.fbf-error');
    if (!message) {
      if (error) error.remove();
      wrap.querySelector('input').removeAttribute('aria-invalid');
      return;
    }
    if (!error) {
      error = el('p', 'fbf-error');
      error.id = 'fbf-name-error';
      error.setAttribute('role', 'alert');
      wrap.appendChild(error);
    }
    error.textContent = message;
    var input = wrap.querySelector('input');
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', 'fbf-name-error');
    input.focus();
  };

  /* Resolves who this save is for, or shows why it can't be saved yet. */
  Picker.prototype.target = function () {
    this.adoptTypedName();
    if (this.current.key !== NEW_KEY) return { forName: this.current.name, friendId: this.current.friendId, key: this.current.key };
    var input = this.q('[data-fbf-for-name]');
    var name = cleanName(input ? input.value : '');
    if (name.error) {
      this.setNameError(name.error);
      return null;
    }
    var match = this.member ? this.member.people.filter(function (p) { return forKey(p.name) === forKey(name.value); })[0] : null;
    if (match) return { forName: match.name, friendId: match.id, key: 'friend:' + match.id };
    return { forName: name.value, friendId: null, key: forKey(name.value) };
  };

  Picker.prototype.continueOn = function () {
    var target = this.target();
    if (!target) return;
    if (!this.dirty()) return;
    if (this.member || this.contact) return this.save(target);
    this.openSheet('contact', target);
  };

  Picker.prototype.openSheet = function (state, target) {
    this.pending = target || this.pending;
    var sheet = this.q('[data-fbf-sheet]');
    this.lastFocus = root.document.activeElement;
    sheet.hidden = false;
    root.document.documentElement.classList.add('fbf-sheet-open');
    this.qa('[data-fbf-state]').forEach(function (node) { node.hidden = node.getAttribute('data-fbf-state') !== state; });
    if (state === 'contact') {
      var flowers = this.selection().map(function (h) { return flowerName(this.catalogue, h); }, this);
      this.q('[data-fbf-contact-summary]').textContent = (this.pending.forName ? possessive(this.pending.forName) + ' favourites: ' : 'Your favourites: ') + listNames(flowers, 4) + '.';
      this.showError(null);
      var email = this.q('#fbf-email');
      if (email) root.setTimeout(function () { email.focus(); }, 30);
    } else {
      var done = this.q('[data-fbf-state="done"]');
      root.setTimeout(function () { done.focus(); }, 30);
    }
  };

  Picker.prototype.closeSheet = function (keepFocus) {
    var sheet = this.q('[data-fbf-sheet]');
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    root.document.documentElement.classList.remove('fbf-sheet-open');
    if (!keepFocus && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Picker.prototype.showError = function (message) {
    var error = this.q('[data-fbf-error]');
    error.hidden = !message;
    error.textContent = message || '';
  };

  /* The pass from an earlier verified save, when it is for this address
     and mobile (the service checks it again). */
  Picker.prototype.passFor = function (email, phone) {
    var pass = this.smsPass;
    return pass && pass.email === email && pass.phone === phone ? pass.value : null;
  };

  Picker.prototype.showCodeStep = function (visible) {
    var wrap = this.q('[data-fbf-code-wrap]');
    wrap.hidden = !visible;
    this.q('[data-fbf-submit]').textContent = visible ? 'Confirm and save' : 'Save my favourites';
    if (!visible) this.q('#fbf-code').value = '';
  };

  Picker.prototype.sendCode = async function (phone) {
    try {
      await this.api.requestSmsCode(phone);
    } catch (error) {
      return this.showError(friendlyError(error, 'We couldn\u2019t send a code just now. Please try again in a moment.'));
    }
    this.showError(null);
    this.showCodeStep(true);
    var code = this.q('#fbf-code');
    root.setTimeout(function () { code.focus(); }, 30);
  };

  /* Texts need the mobile proven: the first save with texts sends a code
     (the same one Reminders sign-in uses) and saves once it is typed. */
  Picker.prototype.submitContact = function () {
    var form = this.q('[data-fbf-state="contact"]');
    var email = form.elements.email.value.trim();
    var sms = form.elements.sms.checked;
    var phone = form.elements.phone.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.showError('Enter your email address.');
    if (sms && phone.replace(/\D/g, '').length < 9) return this.showError('Enter your mobile, or untick texts.');
    var contact = { email: email, sms: sms, phone: phone, code: null };
    if (sms && !this.passFor(email, phone)) {
      if (this.q('[data-fbf-code-wrap]').hidden) {
        if (!this.api) return this.showError('Saving is unavailable right now. Please try again soon.');
        return this.sendCode(phone);
      }
      contact.code = form.elements.code.value.replace(/\D/g, '');
      if (contact.code.length !== 6) return this.showError('Enter the 6-digit code we texted you.');
    }
    this.contact = contact;
    this.save(this.pending);
  };

  Picker.prototype.save = async function (target) {
    if (!this.api) return this.fail('Saving is unavailable right now. Please try again soon.');
    var flowers = this.selection().slice();
    var buttons = [this.q('[data-fbf-continue]'), this.q('[data-fbf-submit]')];
    buttons.forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); } });
    try {
      if (this.member) {
        var response = await this.api.putMyFlowers(memberPayload({ flowers: flowers, forName: target.forName, friendId: target.friendId, touchpoint: this.touchpoint }));
        var group = response.saved || { forName: target.forName, friendId: target.friendId, flowers: flowers };
        this.afterSave(target, group.flowers);
      } else {
        var contact = this.contact;
        var result = await this.api.saveFlowerFavourites(publicPayload({
          flowers: flowers, forName: target.forName, email: contact.email,
          sms: contact.sms, phone: contact.phone, code: contact.code,
          smsPass: contact.sms ? this.passFor(contact.email, contact.phone) : null,
          touchpoint: this.touchpoint
        }));
        // A code works once. The pass lets the next person in this visit
        // keep texts on without another one.
        contact.code = null;
        if (result && result.smsPass) this.smsPass = { email: contact.email, phone: contact.phone, value: result.smsPass };
        this.showCodeStep(false);
        this.afterSave(target, flowers);
      }
    } catch (error) {
      var field = error && error.field;
      if (field === 'email' || field === 'phone' || field === 'code') {
        this.contact = null;
        if (field === 'code') this.smsPass = null;
      }
      if (field === 'forName') this.closeSheet(true);
      this.fail(friendlyError(error, 'We couldn\u2019t save that just now. Please try again in a moment.'), field);
    } finally {
      buttons.forEach(function (b) { if (b) { b.disabled = false; b.removeAttribute('aria-busy'); } });
    }
  };

  Picker.prototype.fail = function (message, field) {
    if (field === 'forName') return this.setNameError(message);
    var sheet = this.q('[data-fbf-sheet]');
    if (!sheet.hidden && !this.q('[data-fbf-state="contact"]').hidden) return this.showError(message);
    if (!this.contact && !this.member && (field === 'email' || field === 'phone' || field === 'code')) {
      this.openSheet('contact', this.pending);
      if (field === 'code') this.showCodeStep(false);
      return this.showError(field === 'code' ? 'Confirm your mobile again to keep texts on.' : message);
    }
    this.q('[data-fbf-tray]').hidden = false;
    this.q('[data-fbf-tray-text]').textContent = message;
  };

  Picker.prototype.afterSave = function (target, flowers) {
    var previous = this.current.key;
    this.saved[target.key] = flowers.slice();
    this.chosen[target.key] = flowers.slice();
    if (previous === NEW_KEY) this.chosen[NEW_KEY] = [];
    this.current = { key: target.key, name: target.forName || null, friendId: target.friendId || null };
    if (!this.member) this.addLocalChip(target);
    else this.member.groups = this.member.groups.filter(function (g) { return (g.friendId ? 'friend:' + g.friendId : forKey(g.forName)) !== target.key; })
      .concat(flowers.length ? [{ forName: target.forName || null, friendId: target.friendId || null, flowers: flowers.slice() }] : []);
    if (this.member) this.renderWho();
    this.render();

    var thumbs = this.q('[data-fbf-done-thumbs]');
    thumbs.textContent = '';
    var self = this;
    flowers.slice(0, 6).forEach(function (h) { thumbs.appendChild(thumb(self.catalogue, h, 'fbf-done__thumb')); });
    this.q('[data-fbf-done-heading]').textContent = flowers.length ? 'Lovely. Saved.' : 'Cleared';
    var body = doneMessage(this.catalogue, flowers, target.forName);
    // Signed out, the address is confirmed by email before any alert goes
    // there (the service sends the link). Said once a visit.
    if (!this.member && !this.confirmNoted && flowers.length) {
      body += ' ' + CONFIRM_NOTE;
      this.confirmNoted = true;
    }
    this.q('[data-fbf-done-body]').textContent = body;
    var reminders = this.q('[data-fbf-reminders-link]');
    if (reminders) reminders.hidden = !this.member;
    this.openSheet('done');
    if (root.FBPostHog && typeof root.FBPostHog.capture === 'function') {
      try { root.FBPostHog.capture('favourite_flowers_saved', { count: flowers.length, for_self: !target.forName, member: !!this.member, touchpoint: this.touchpoint }); } catch (_) {}
    }
  };

  /* Signed out: a saved person becomes a chip, so the shopper can go back. */
  Picker.prototype.addLocalChip = function (target) {
    if (!target.forName) return;
    if (this.q('[data-fbf-who-option][data-for-key="' + target.key + '"]')) return;
    var chip = el('button', 'fbf__chip', target.forName);
    chip.type = 'button';
    chip.setAttribute('role', 'radio');
    chip.setAttribute('data-fbf-who-option', '');
    chip.setAttribute('data-for-key', target.key);
    chip.setAttribute('data-for-name', target.forName);
    var add = this.q('[data-fbf-who-option][data-for-key="' + NEW_KEY + '"]');
    add.parentNode.insertBefore(chip, add);
  };

  Picker.prototype.another = function () {
    this.closeSheet(true);
    this.startNewPerson('');
    this.chosen[NEW_KEY] = [];
    this.filter = 'all';
    this.render();
    var who = this.q('.fbf__who');
    if (who && who.scrollIntoView) who.scrollIntoView({ block: 'start', behavior: 'smooth' });
    var input = this.q('[data-fbf-for-name]');
    if (input) root.setTimeout(function () { input.focus({ preventScroll: true }); }, 300);
  };

  /* ---------- the Reminders summary ---------- */

  function Summary(element) {
    this.el = element;
    this.catalogue = readCatalogue(root.document);
    this.api = apiFor(element);
  }

  /* One read for every summary on the page (the list and the person view
     both carry one), so the member's favourites are fetched once. */
  var memberFlowers = null;
  function readMemberFlowers(api) {
    if (!memberFlowers) {
      memberFlowers = (async function () {
        var me = await api.me();
        if (!me || !me.signedIn) return null;
        return api.getMyFlowers();
      })().catch(function () { return null; });
    }
    return memberFlowers;
  }

  Summary.prototype.init = async function () {
    try {
      if (!this.api || this.catalogue.list.length === 0) return;
      var data = await readMemberFlowers(this.api);
      if (!data) return;
      this.render(data.groups || [], data.people || []);
    } finally {
      // The Reminders list waits for this on desktop (assets/fb-reminders.js).
      this.el.removeAttribute('data-fb-card-pending');
    }
  };

  Summary.prototype.render = function (groups, people) {
    var self = this;
    var friendId = null;
    if (this.el.hasAttribute('data-fb-flowers-friend')) {
      friendId = new root.URLSearchParams(root.location.search).get('id');
      if (!friendId) return;
    }
    var shown = friendId ? groups.filter(function (g) { return g.friendId === friendId; }) : groups;
    var person = friendId ? people.filter(function (p) { return p.id === friendId; })[0] : null;
    if (friendId && !person) return;

    this.el.textContent = '';
    var heading = el('h2', 'fbf-summary__heading', person ? possessive(person.name) + ' favourite flowers' : 'Favourite flowers');
    this.el.appendChild(heading);

    if (shown.length === 0) {
      var prompt = el('div', 'fbf-summary__prompt');
      prompt.appendChild(el('p', null, person
        ? 'Know what ' + person.name + ' loves? Tell us, and we’ll let you know when it’s back in season.'
        : 'Tell us the flowers you and your people love. We’ll let you know when each comes back into season.'));
      var link = el('a', this.el.hasAttribute('data-fb-collapse') ? 'fb-reminders-card__primary' : 'button button--secondary', person ? 'Choose ' + possessive(person.name) + ' flowers' : 'Add someone’s favourites →');
      link.href = pickerUrl(person ? { friendId: person.id } : null, person ? 'reminders-person' : 'reminders-list');
      if (this.el.hasAttribute('data-fb-collapse')) { this.el.appendChild(prompt); this.el.appendChild(link); }
      else { prompt.appendChild(link); this.el.appendChild(prompt); }
      this.el.hidden = false;
      return;
    }

    var list = el('ul', 'fbf-summary__list');
    list.setAttribute('role', 'list');
    var dashboard = this.el.hasAttribute('data-fb-collapse');
    (dashboard ? shown.slice(0, 1) : shown).forEach(function (group) {
      var row = el('li', 'fbf-summary__row');
      var thumbs = el('span', 'fbf-summary__thumbs');
      thumbs.setAttribute('aria-hidden', 'true');
      group.flowers.slice(0, 4).forEach(function (h) { thumbs.appendChild(thumb(self.catalogue, h, 'fbf-summary__thumb')); });
      row.appendChild(thumbs);
      var text = el('span', 'fbf-summary__text');
      if (!person) text.appendChild(el('strong', null, group.forName || 'You'));
      text.appendChild(el('span', null, listNames(group.flowers.map(function (h) { return flowerName(self.catalogue, h); }), 4)));
      row.appendChild(text);
      var edit = el('a', 'fbf-summary__edit', dashboard ? 'View' : 'Edit');
      edit.href = pickerUrl(dashboard && shown.length > 1 ? null : group, person ? 'reminders-person' : 'reminders-list');
      edit.setAttribute('aria-label', dashboard ? 'View favourite flowers' : 'Edit ' + (group.forName ? possessive(group.forName) : 'your') + ' favourite flowers');
      row.appendChild(edit);
      list.appendChild(row);
    });
    this.el.appendChild(list);
    if (dashboard && shown.length > 1) this.el.appendChild(el('p', 'fb-reminders-card__additional', 'Saved for ' + shown.length + ' people. Select View to see all.'));
    if (!person) {
      var more = el('a', 'fb-reminders-card__primary', 'Add someone’s favourites →');
      more.href = pickerUrl(null, 'reminders-list');
      this.el.appendChild(more);
    }
    this.el.hidden = false;
  };

  function start() {
    var doc = root.document;
    if (!doc) return;
    Array.prototype.forEach.call(doc.querySelectorAll('fb-favourite-flowers'), function (node) {
      if (node.__fbf) return;
      node.__fbf = new Picker(node);
      node.__fbf.init();
    });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-fb-flowers-summary]'), function (node) {
      if (node.__fbf) return;
      node.__fbf = new Summary(node);
      node.__fbf.init();
    });
  }

  if (root.document && typeof module === 'undefined') {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start);
    else start();
    root.document.addEventListener('shopify:section:load', start);
  }

  return {
    flowerVisible: flowerVisible,
    cleanName: cleanName,
    forKey: forKey,
    possessive: possessive,
    listNames: listNames,
    readCatalogue: readCatalogue,
    flowerName: flowerName,
    doneMessage: doneMessage,
    trayMessage: trayMessage,
    friendlyError: friendlyError,
    CONFIRM_NOTE: CONFIRM_NOTE,
    publicPayload: publicPayload,
    memberPayload: memberPayload,
    pickerUrl: pickerUrl,
    touchpointFrom: touchpointFrom,
    Picker: Picker,
    Summary: Summary,
    start: start
  };
});
